import {
  OrderSettlementMethod,
  OrderStatus,
  ServicePaymentMethod,
  ServiceFormsType,
  ServiceType,
} from "@/apis/clients";

export const serviceTypeToString = (value: ServiceType) => {
  switch (value) {
    // case ServiceType.EVENT_SEMINAR_FREE:
    //   return "イベント・セミナー（無料）";
    // case ServiceType.EVENT_SEMINAR:
    //   return "イベント・セミナー（有料）";
    // case ServiceType.CALENDAR_RESERVATION:
    //   return "カレンダー予約";
    // case ServiceType.SCHOOL_SERVICE_FREE:
    //   return "スクールサービス（無料）";
    // case ServiceType.SCHOOL_SERVICE:
    //   return "スクールサービス（有料）";
    // case ServiceType.MEETING:
    //   return "面談・ミーティング";
    // case ServiceType.FREE_CONTENT_WEBINAR:
    //   return "コンテンツ・ウェビナー（無料）";
    // case ServiceType.REGIST_MAIL_MAGAZINE:
    //   return "メルマガ登録";
    // case ServiceType.COUPON:
    //   return "割引クーポン";
    // case ServiceType.QUESTIONNAIRE:
    //   return "アンケート";
    // case ServiceType.CONTENT_SALES:
    //   return "コンテンツ・ウェビナー（有料）";
    case ServiceType.SUBSCRIPTION_SERVICE:
      return "サブスクサービス";
    case ServiceType.EVENT_SEMINAR:
      return "イベントセミナー";
    case ServiceType.CALENDAR_RESERVATION:
      return "カレンダー";
    case ServiceType.FORM:
      return "フォーム";
    case ServiceType.SURVEY:
      return "アンケート";
    case ServiceType.DOCUMENT_REQUEST:
      return "資料請求";
    case ServiceType.INQUIRY:
      return "問い合わせ";
    case ServiceType.EMAIL_NEWSLETTER:
      return "メルマガ登録";
    default:
      return "サービスタイプが不正です";
  }
};

/**
 * 支払い方法の値を画面表示用に変換
 * @param value
 * @returns
 */
export const paymentMethodToString = (value: ServicePaymentMethod) => {
  switch (value) {
    // case ServicePaymentMethod.FREE:
    //   return "無料";
    case ServicePaymentMethod.CREDIT:
      return "クレジットカード";
    case ServicePaymentMethod.BANK:
      return "銀行振込";
    case ServicePaymentMethod.LOCAL_PAYMENT:
      return "現地払い";
    case ServicePaymentMethod.PAYPAL:
      return "PayPal";
    default:
      throw new Error("支払い方法が不正です");
  }
};

export const settlementMethodToString = (value: OrderSettlementMethod) => {
  switch (value) {
    case OrderSettlementMethod.FREE:
      return "無料";
    case OrderSettlementMethod.CREDIT:
      return "クレジットカード";
    case OrderSettlementMethod.BANK:
      return "銀行振込";
    case OrderSettlementMethod.LOCAL_PAYMENT:
      return "現地払い";
    case OrderSettlementMethod.PAYPAL:
      return "PayPal";
    default:
      throw new Error("支払い方法が不正です");
  }
};

export const serviceSNSFormTypeToString = (value: ServiceFormsType) => {
  switch (value) {
    case ServiceFormsType.FACEBOOK_ID:
      return "Facebook ID";
    case ServiceFormsType.TWITTER_ID:
      return "X ID";
    case ServiceFormsType.INSTAGRAM_ID:
      return "Instagram ID";
    default:
      return "";
  }
};

export const orderStatusToString = (value: OrderStatus) => {
  switch (value) {
    case OrderStatus.UNPAID:
      return "未入金";
    case OrderStatus.BILLED:
      return "決済済み";
    // case OrderStatus.PAID:
    //   return "入金済";
    // case OrderStatus.COMPLETION:
    //   return "購入・受講終了";
    case OrderStatus.CANCEL:
      return "キャンセル";
    case OrderStatus.WAITINGCANCEL:
      return "解約受付済み";
    // case OrderStatus.FINISHED:
    // return "現地決済";
    case OrderStatus.FREE_FINISHED:
      return "申し込み完了（決済なし）";
    case OrderStatus.TRIALING:
      return "トライアル中";
    default:
      throw new Error("属性が不正です");
  }
};

export const newOrderStatusToString = (value: OrderStatus) => {
  switch (value) {
    case OrderStatus.UNPAID:
      return "未入金";
    case OrderStatus.BILLED:
      return "決済済み";
    // case OrderStatus.PAID:
    //   return "入金済";
    // case OrderStatus.COMPLETION:
    //   return "購入・受講終了";
    case OrderStatus.CANCEL:
      return "キャンセル";
    case OrderStatus.WAITINGCANCEL:
      return "解約受付済み";
    // case OrderStatus.FINISHED:
    //   return "現地決済";
    case OrderStatus.FREE_FINISHED:
      return "申込完了 / 無料";
    case OrderStatus.TRIALING:
      return "トライアル中";
    default:
      throw new Error("属性が不正です");
  }
};
